var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isGranted('ROLE_COMPANY_SHOW'))?_c('router-link',{attrs:{"to":{name: 'CompanyShow', params: { id: _vm.data['@id'] }}}},[_vm._v("\n    "+_vm._s(_vm.data.code)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e26809c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/table/ColumnCode.vue
// module id = 714
// module chunks = 0